import React, { useEffect, useState } from "react";
import { Color } from "@material-ui/lab/Alert";
import { CcpSnackbar } from "../components/base/CcpSnackbar";
import { CcpAlert } from "../models/CcpAlert";
import ConfigurationService from "../services/ConfigurationService";
import { getLogger } from "../services/LoggingService";

const logger = getLogger("AppContextProvider");

export interface IAppContext {
    config: ConfigurationService;
    setAlert: (message: string, type: Color, timeout?: number) => void;
}

export const AppContext = React.createContext<IAppContext>(null as any);

export function AppContextProvider(props: { children: any }) {
    const [status, setStatus] = useState("Loading");
    const [alert, setAlert] = useState<CcpAlert | undefined>();
    const [config] = useState(new ConfigurationService());

    useEffect(() => {
        (async () => {
            try {
                await config.load();
                setStatus("Ready");
            } catch (error) {
                const message = (error as any).message || error;
                logger.error(`Configuration Failed: ${message}`, error);
                setStatus(message);
            }
        })();
    }, [config]);

    if (status !== "Ready") {
        return (
            <div>
                <p>{status}</p>
            </div>
        );
    }

    const ctx: IAppContext = {
        config,
        setAlert: (message, type, timeout) => setAlert(new CcpAlert(message, type, timeout)),
    };

    return (
        <AppContext.Provider value={ctx}>
            {alert && <CcpSnackbar alert={alert} clear={() => setAlert(undefined)} />}
            {props.children}
        </AppContext.Provider>
    );
}

export default AppContext;
